import { pbrExt } from './fragments/iridescence-fragment.js';
import { _registerPbrExt } from './pbr-flags.js';

function setPbrIridescence(mat, iridescence) {
  mat._iridescence = iridescence;
  _registerPbrExt(pbrExt);
}

export { setPbrIridescence };
//# sourceMappingURL=set-iridescence.js.map
